import React, { FC, memo, useMemo } from 'react'

import Select from 'components/Inputs/Select'
import { OptionSelectType } from 'components/Inputs/Select/props'
import { useAuth } from 'hooks/auth'

import { SelectRolesProps } from './props'
import { useRoles } from './useRoles'

const SelectRoles: FC<SelectRolesProps> = props => {
  const { roles } = useRoles()
  const { hasRole } = useAuth()

  const options = useMemo<OptionSelectType[]>(() => {
    if (!roles) return []

    return roles
      .filter(role => {
        if (
          hasRole('dev') &&
          (role.name === 'dev' ||
            role.name === 'admin' ||
            role.name === 'financial' ||
            role.name === 'financial_collection' ||
            role.name === 'distributor')
        ) {
          return true
        }
        if (
          (hasRole('admin') && role.name === 'admin') ||
          role.name === 'financial' ||
          role.name === 'financial_collection' ||
          role.name === 'distributor'
        ) {
          return true
        }
        return false
      })
      .map(role => ({
        name: role.translated_name,
        value: role.name,
      }))
  }, [hasRole, roles])

  return (
    <Select
      name="role_name"
      label="Tipo de usuário"
      options={options}
      {...props}
    />
  )
}

export default memo(SelectRoles)
